function indexOfKeyInHashArray(array, type, key) {
    for (const idx in array) {
        if (array[idx][type] && array[idx][type].hasOwnProperty(key))
            return idx;
    }
    return -1;
}
export function initialFiltered() {
    return {
        filter: {
            bool: {
                must: [],
                must_not: [],
            },
        },
    };
}
function addFilter(filters, newFilters) {
    const result = filters;
    for (const filterType in newFilters) {
        for (const key in newFilters[filterType]) {
            const term = {};
            term[key] = newFilters[filterType][key];
            const idx = indexOfKeyInHashArray(result, filterType, key);
            if (idx === -1)
                result.push(newFilters);
            else
                result[idx] = newFilters;
        }
    }
    return result;
}
export class QueryBuilder {
    constructor() {
        this.body = {
            query: {
                filtered: initialFiltered(),
            },
        };
    }
    size(limit) {
        this.body.size = limit;
        return this;
    }
    from(offset) {
        this.body.from = offset;
        return this;
    }
    sort(key, order, mode) {
        this.body.sort = {};
        this.body.sort[key] = { order };
        if (mode)
            this.body.sort[key].mode = mode;
        return this;
    }
    raw(filterObj) {
        this.body.query.filtered.filter.bool.must = addFilter(this.body.query.filtered.filter.bool.must, filterObj);
        return this;
    }
    filter(filterObj) {
        let isArray = false;
        for (const key in filterObj) {
            if (Array.isArray(filterObj[key])) {
                isArray = true;
                break;
            }
        }
        const obj = (isArray) ? { terms: filterObj } : { term: filterObj };
        this.body.query.filtered.filter.bool.must = addFilter(this.body.query.filtered.filter.bool.must, obj);
        return this;
    }
    filterNot(filterObj) {
        this.body.query.filtered.filter.bool.must_not = addFilter(this.body.query.filtered.filter.bool.must_not, { term: filterObj });
        return this;
    }
    filterOr(filterObjs) {
        const newOrs = filterObjs.map((filterObj) => {
            return { term: filterObj };
        });
        this.body.query.filtered.filter.bool.must =
            this.body.query.filtered.filter.bool.must.concat({ or: newOrs });
        return this;
    }
    filterMissing(field) {
        this.body.query.filtered.filter.bool.must = addFilter(this.body.query.filtered.filter.bool.must, { missing: { field: field } });
        return this;
    }
    filterGeo(filterObjs) {
        if (filterObjs.origin) {
            this.body.query.filtered.filter.bool.must = addFilter(this.body.query.filtered.filter.bool.must, filterObjs.origin);
        }
        if (filterObjs.destination) {
            this.body.query.filtered.filter.bool.must = addFilter(this.body.query.filtered.filter.bool.must, filterObjs.destination);
        }
        return this;
    }
    range(key, start, end) {
        const filterObj = {};
        filterObj[key] = {};
        if (start)
            filterObj[key].gte = start;
        if (end)
            filterObj[key].lte = end;
        this.body.query.filtered.filter.bool.must = addFilter(this.body.query.filtered.filter.bool.must, { range: filterObj });
        return this;
    }
    match(keywords) {
        this.body.query.filtered.query = {
            match: {
                _all: {
                    query: keywords.join(' '),
                    operator: 'and',
                },
            },
        };
        return this;
    }
}
